import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

// withCredentials so the HttpOnly auth cookie is sent with every request.
const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

function getCookie(name) {
  const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
  return m ? m.pop() : "";
}

api.interceptors.request.use((config) => {
  // Double-submit CSRF: echo the readable csrf_token cookie in a header.
  const csrf = getCookie("csrf_token");
  if (csrf) config.headers["X-CSRF-Token"] = csrf;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export default api;
